import React, { useState } from 'react';
import Modal from 'react-modal';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa'; // Importamos los iconos de flechas
import './VideoComponent.css'; // Si usas un archivo CSS para estilos

Modal.setAppElement('#root');  // Asegura que el modal se pueda acceder correctamente en React

const VideoComponent = ({ videos }) => {

  // Estado para controlar el modal
  const [isOpen, setIsOpen] = useState(false);

  // Estado para controlar el video actual
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);  // Usamos índice en lugar de la URL directa

  // Abrir modal
  const openModal = () => setIsOpen(true);

  // Cerrar modal
  const closeModal = () => setIsOpen(false);

    // Verificar si el arreglo de videos está vacío o es null
    if (!videos || videos.length === 0) {
      return;
      // return <p>No hay videos disponibles.</p>; // Mensaje si no hay videos
    }


  // Cambiar al siguiente video
  const nextVideo = () => {
    setCurrentVideoIndex((prevIndex) => (prevIndex + 1) % videos.length);
  };

  // Cambiar al video anterior
  const prevVideo = () => {
    setCurrentVideoIndex((prevIndex) => (prevIndex - 1 + videos.length) % videos.length);
  };

  return (
    <div>
      { <button onClick={openModal}>Ver  Videos</button> }

      {/* Overlay de fondo oscuro */}
      {isOpen && <div className="modal-overlay" onClick={closeModal}></div>}

      <Modal isOpen={isOpen} onRequestClose={closeModal} contentLabel="Video Modal" className="modal-content">
        <button onClick={closeModal} className="video-close-btn">X</button>
        
        {/* Contenedor de video */}
        <div className="video-container">
          <iframe
            id="facebook-video"
            src={`https://www.facebook.com/plugins/video.php?href=${videos[currentVideoIndex]}&force_video=true&show_text=0&autoplay=1&muted=0 &playsinline=true`}
            scrolling="no"
            frameBorder="0"
            allowFullScreen="true"
            title="Facebook Video"
          />
        </div>

        {/* Navegación con flechas */}
        <div className="video-navigation">
          <button onClick={prevVideo} className="nav-button left-arrow">
            <FaArrowLeft size={30} />
          </button>
          <button onClick={nextVideo} className="nav-button left-arrow">
            <FaArrowRight size={30} />
          </button>
        </div>
      </Modal>
    </div>
  );
};

export default VideoComponent;


// import React, { useState } from 'react';
// import Modal from 'react-modal';
// import './VideoComponent.css'; // Asegúrate de que este archivo contenga los estilos mencionados

// const VideoComponent = () => {
//   const [modalIsOpen, setModalIsOpen] = useState(false);

  // console.log("Estos son los videos recibidos:", videos);

  // Arreglo de URLs de videos
  // const videoUrls = [
  //   "https://www.facebook.com/61552559032313/videos/1698614480727377",
  //   "https://www.facebook.com/100063504822585/videos/1100554362182003",  // Primer video
  //   "https://www.facebook.com/reel/964858514978259",  // Segundo video
  //   "https://www.facebook.com/reel/352177051075533",  // Tercer video
  // ];

//   const openModal = () => setModalIsOpen(true);
//   const closeModal = () => setModalIsOpen(false);

//   return (
//     <div>
//       <button onClick={openModal}>Ver Video</button>
//       <Modal
//         isOpen={modalIsOpen}
//         onRequestClose={closeModal}
//         contentLabel="Video de Facebook"
//         style={{
//           content: {
//             top: '50%',
//             left: '50%',
//             right: 'auto',
//             bottom: 'auto',
//             transform: 'translate(-50%, -50%)',
//             width: '80%', // Ajusta el ancho del modal según sea necesario
//             height: '80%', // Ajusta la altura del modal según sea necesario
//             padding: '0px',
//             border: 'none',
//              background: 'black', 
//           },
//           overlay: {
//             backgroundColor: 'rgba(0, 0, 0, 0.75)', // Fondo oscuro para enfoque
//           },
//         }}
//       >
//         <div className="video-container">
//           <iframe
            
//             src="https://www.facebook.com/plugins/video.php?href=https://www.facebook.com/reel/964858514978259&show_text=0"
//             frameBorder="0"
//             allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
//             allowFullScreen
//             title="Video de Facebook"
//             className="video-iframe"
//           />
//         </div>
//         <button
//           onClick={closeModal}
//           style={{
//             position: 'absolute',
//             top: '10px',
//             right: '10px',
//             backgroundColor: 'transparent',
//             border: 'none',
//             color: '#fff',
//             fontSize: '24px',
//           }}
//         >
//           &times;
//         </button>
//       </Modal>
//     </div>
//   );
// };

// export default VideoComponent;
